const DEMANDE_TNT = 'DEMANDE_TNT';

import { $qProvider } from '../providers';
import LZString from 'lz-string';

function loadDemande() {
  const serialized = window.localStorage.getItem(DEMANDE_TNT);
  return $qProvider().when(serialized ? JSON.parse(LZString.decompress(serialized)) : {});
}

function cacheDemande(demande) {
  if (demande) {
    let jsonData = JSON.stringify(demande);
    let compressedData = LZString.compress(jsonData);
    window.localStorage.setItem(DEMANDE_TNT, compressedData);
  } else {
    window.localStorage.removeItem(DEMANDE_TNT);
  }
  return $qProvider().when(true);
}

export default {
  loadDemande,
  cacheDemande
};



// WEBPACK FOOTER //
// ./src/repositories/demande.repository.js